import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.auth.issuer,
  clientId: environment.auth.clientId,
  responseType: 'code',
  redirectUri: window.location.origin + '/',
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  postLogoutRedirectUri: window.location.origin + '/',
  scope: environment.auth.scope,
  useSilentRefresh: true,
  silentRefreshTimeout: environment.auth.silentRefreshTimeout,
  timeoutFactor: environment.auth.timeoutFactor,
  sessionChecksEnabled: true,
  showDebugInformation: environment.auth.showDebugInformation,
  clearHashAfterLogin: false,
  nonceStateSeparator: 'semicolon',
  customQueryParams: {
    audience: environment.auth.audience
  }
};
